/** True only when full SEO (meta, GTM, tracking) should be rendered and fetched. */
export function isSeoProductionEnv() {
  return process.env.NEXT_PUBLIC_ENV === "production";
}
